// extracted by mini-css-extract-plugin
module.exports = {"fouth_section":"Testinomials_fouth_section__rkV9c","heading":"Testinomials_heading__uam9h","container_padding":"Testinomials_container_padding__UDhMJ"};